import {isMobile} from "../../js/global-scripts"

const cards = [...document.querySelectorAll('.card-project')]

const cardOptions = {
    classTouch: 'card-project--touch',
    setActive: (card, e) => {
        card.classList.add('is-active')
    },
    unsetActive: (card, e) => {
        card.classList.remove('is-active')
    },
    clickNav: (card, e) => {
        const btn = e.target.closest('.card-project__nav')
        if (!btn) return

        e.preventDefault()
        const {method} = btn.dataset

        switch (method) {
            case 'set':
                cardOptions.setActive(card)
                break
            case 'unset':
                cardOptions.unsetActive(card)
                break
        }
    }
}

cards.forEach(card => {
    if (!isMobile.any()) {
        card.classList.remove(cardOptions.classTouch)
        card.addEventListener('mouseenter', cardOptions.setActive.bind(null, card))
        card.addEventListener('mouseleave', cardOptions.unsetActive.bind(null, card))

        return
    }

    card.classList.add(cardOptions.classTouch)

    card.addEventListener('click', cardOptions.clickNav.bind(null, card))
})